import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { getThingnarioOverviewApi, getThingnarioPlantInvertersApi } from '@/api/otherSources';

import dayjs from 'dayjs';
var LEVEL_ORDER = {
  fault: 0,
  warn: 1,
  info: 2
};
export default {
  name: 'ThingnarioPanel',
  data: function data() {
    return {
      loading: false,
      plants: [],
      errors: [],
      fetchedAt: null,
      stale: false,
      daytime: true,
      opened: {},
      detail: {},
      detailLoading: {},
      detailError: {},
      focusedPlant: null
    };
  },
  computed: {
    fetchedAtText: function fetchedAtText() {
      return this.fetchedAt ? dayjs(this.fetchedAt).format('MM/DD HH:mm') : '';
    },
    /**
     * 「資料停止更新」跟「日落後不再更新」都會讓畫面停住，但該做的事完全相反：
     * 前者要通報，後者什麼都不用做。講同一句話會讓人白緊張或忽略真問題。
     *
     * ⚠️ 這頁改讀 BigQuery 之後就不再打慧景 API，所以停更**不再是配額問題**。
     * 舊文案寫「API 額度不足」會把人指向錯誤的方向。
     */
    statusNote: function statusNote() {
      if (this.stale) {
        return {
          text: '資料停止更新',
          variant: 'danger',
          hint: '白天超過 45 分鐘未收到新資料，請洽資訊人員'
        };
      }
      if (!this.daytime) {
        return {
          text: '日落後不再更新',
          variant: 'secondary',
          hint: '每日 19:00 至隔日 06:00 不更新，日落後發電資料不再變動'
        };
      }
      return null;
    },
    allAlerts: function allAlerts() {
      return this.plants.flatMap(function (p) {
        return p.alerts.map(function (a) {
          return _objectSpread(_objectSpread({}, a), {}, {
            plantName: p.name,
            plantNo: p.plantNo
          });
        });
      }).sort(function (a, b) {
        return LEVEL_ORDER[a.level] - LEVEL_ORDER[b.level];
      });
    },
    faultCount: function faultCount() {
      return this.countLevel('fault');
    },
    warnCount: function warnCount() {
      return this.countLevel('warn');
    },
    infoCount: function infoCount() {
      return this.countLevel('info');
    },
    sortedPlants: function sortedPlants() {
      // 有問題的排前面，維運不用自己找
      return _toConsumableArray(this.plants).sort(function (a, b) {
        var _LEVEL_ORDER$a$level, _LEVEL_ORDER$b$level;
        return ((_LEVEL_ORDER$a$level = LEVEL_ORDER[a.level]) !== null && _LEVEL_ORDER$a$level !== void 0 ? _LEVEL_ORDER$a$level : 3) - ((_LEVEL_ORDER$b$level = LEVEL_ORDER[b.level]) !== null && _LEVEL_ORDER$b$level !== void 0 ? _LEVEL_ORDER$b$level : 3);
      });
    },
    kpis: function kpis() {
      var _this = this;
      var sum = function sum(fn) {
        return _this.plants.reduce(function (s, p) {
          return s + (fn(p) || 0);
        }, 0);
      };
      var prs = this.plants.map(function (p) {
        return p.prToday;
      }).filter(function (v) {
        return v != null;
      });
      var avgPr = prs.length ? prs.reduce(function (s, v) {
        return s + v;
      }, 0) / prs.length : null;
      return [{
        label: '案場數',
        value: this.plants.length,
        unit: ' 座',
        tone: ''
      }, {
        label: '今日總發電',
        value: this.fmt(sum(function (p) {
          return p.energyToday;
        }), 1),
        unit: ' kWh',
        tone: ''
      }, {
        label: '即時總發電功率',
        value: this.fmt(sum(function (p) {
          return p.instantPower;
        }), 1),
        unit: ' kW',
        tone: ''
      }, {
        label: '今日平均 PR',
        value: avgPr == null ? '—' : this.fmt(avgPr, 1),
        unit: '%',
        tone: avgPr != null && avgPr < 70 ? 'is-warn' : ''
      }, {
        label: '今日減碳',
        value: this.fmt(sum(function (p) {
          return p.co2Today;
        }), 1),
        unit: ' kg',
        tone: ''
      }, {
        label: '故障告警（紅燈）',
        value: this.faultCount,
        unit: ' 件',
        tone: this.faultCount ? 'is-fault' : ''
      }];
    }
  },
  methods: {
    countLevel: function countLevel(level) {
      return this.allAlerts.filter(function (a) {
        return a.level === level;
      }).length;
    },
    plantKey: function plantKey(p) {
      return "".concat(p.accountId, "-").concat(p.plantNo);
    },
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getThingnarioO, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return getThingnarioOverviewApi();
              case 4:
                _yield$getThingnarioO = _context.sent;
                data = _yield$getThingnarioO.data;
                _this2.plants = data.plants;
                _this2.errors = data.errors;
                _this2.fetchedAt = data.fetchedAt;
                _this2.stale = data.stale;
                _this2.daytime = data.daytime !== false;
                _this2.detail = {};
                _context.next = 17;
                break;
              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);
                _this2.errors = [{
                  msg: '資料讀取失敗，請洽資訊人員'
                }];
              case 17:
                _context.prev = 17;
                _this2.loading = false;
                return _context.finish(17);
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 14, 17, 20]]);
      }))();
    },
    toggle: function toggle(p) {
      var key = this.plantKey(p);
      this.$set(this.opened, key, !this.opened[key]);
      if (this.opened[key] && !this.detail[key]) this.loadDetail(p);
    },
    loadDetail: function loadDetail(p) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var key, _yield$getThingnarioP, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = _this3.plantKey(p);
                _this3.$set(_this3.detailLoading, key, true);
                _this3.$set(_this3.detailError, key, '');
                _context2.prev = 3;
                _context2.next = 6;
                return getThingnarioPlantInvertersApi(p.accountId, p.plantNo);
              case 6:
                _yield$getThingnarioP = _context2.sent;
                data = _yield$getThingnarioP.data;
                _this3.$set(_this3.detail, key, data);
                _context2.next = 14;
                break;
              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);
                _this3.$set(_this3.detailError, key, (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '取不到逆變器資料');
              case 14:
                _context2.prev = 14;
                _this3.$set(_this3.detailLoading, key, false);
                return _context2.finish(14);
              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11, 14, 17]]);
      }))();
    },
    focusPlant: function focusPlant(plantNo) {
      var _this4 = this;
      var p = this.plants.find(function (x) {
        return x.plantNo === plantNo;
      });
      if (!p) return;
      var key = this.plantKey(p);
      if (!this.opened[key]) this.toggle(p);
      this.focusedPlant = plantNo;
      this.$nextTick(function () {
        var el = _this4.$refs["plant-".concat(plantNo)];
        if (el && el[0]) el[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      });
    },
    todayChart: function todayChart(p) {
      var times = p.hourly.map(function (h) {
        return dayjs(h.t).format('HH:mm');
      });
      return {
        chart: {
          height: 150,
          spacing: [6, 4, 2, 0],
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        xAxis: {
          categories: times,
          tickInterval: 3,
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        },
        yAxis: [{
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }, {
          title: {
            text: null
          },
          opposite: true,
          labels: {
            style: {
              fontSize: '10px'
            }
          }
        }],
        tooltip: {
          shared: true,
          valueDecimals: 1
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false
            }
          }
        },
        series: [{
          name: '發電量 kWh',
          type: 'column',
          data: p.hourly.map(function (h) {
            return h.energy;
          }),
          color: '#7cb5ec'
        }, {
          name: '日照 W/m²',
          type: 'spline',
          yAxis: 1,
          data: p.hourly.map(function (h) {
            return h.irradiance;
          }),
          color: '#f0ad4e'
        }]
      };
    },
    weekChart: function weekChart(p) {
      return {
        chart: {
          height: 180,
          spacing: [6, 4, 2, 0],
          backgroundColor: 'transparent'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: true,
          itemStyle: {
            fontSize: '11px'
          }
        },
        xAxis: {
          categories: p.daily.map(function (d) {
            return d.date.slice(5);
          })
        },
        yAxis: {
          title: {
            text: null
          },
          max: 120
        },
        tooltip: {
          shared: true,
          valueSuffix: '%',
          valueDecimals: 1
        },
        series: [{
          name: 'PR',
          type: 'column',
          data: p.daily.map(function (d) {
            return d.pr;
          }),
          color: '#5cb85c'
        }, {
          name: '資料可用率',
          type: 'spline',
          data: p.daily.map(function (d) {
            return d.dataAvailability;
          }),
          color: '#b0b7c3',
          dashStyle: 'ShortDash',
          marker: {
            enabled: true,
            radius: 3
          }
        }]
      };
    },
    maxPr: function maxPr(inverters) {
      return Math.max.apply(Math, _toConsumableArray(inverters.map(function (i) {
        return i.pr || 0;
      })).concat([1]));
    },
    fmt: function fmt(v) {
      var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return v == null ? '—' : Number(v).toFixed(digits);
    },
    pct: function pct(v, max) {
      if (!v || !max) return '0%';
      return "".concat(Math.min(100, v / max * 100).toFixed(1), "%");
    },
    prClass: function prClass(pr) {
      if (pr == null) return '';
      if (pr < 70) return 'is-fault';
      if (pr < 80) return 'is-warn';
      return 'is-ok';
    }
  },
  mounted: function mounted() {
    this.load();
  }
};